import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "topicInput", "charCount", "submitBtn", "successMsg", "errorMsg"]

  connect() {
    this.updateCharCount()
  }

  updateCharCount() {
    if (!this.hasTopicInputTarget || !this.hasCharCountTarget) return
    const len = this.topicInputTarget.value.length
    this.charCountTarget.textContent = `${len}/600`
  }

  async submit(event) {
    event.preventDefault()

    this.hideMessages()

    const form = this.formTarget
    const data = new FormData(form)

    // Client-side validation
    const firstNameOk = data.get("first_name")?.trim()
    const lastNameOk  = data.get("last_name")?.trim()
    const email       = data.get("email")?.trim()
    const humanCheck  = data.getAll("human_check").includes("1")

    if (!firstNameOk || !lastNameOk || !email) {
      this.showError(this.element.dataset.errorRequired)
      return
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.showError(this.element.dataset.errorEmail)
      return
    }

    if (!humanCheck) {
      this.showError(this.element.dataset.errorHuman)
      return
    }

    this.submitBtnTarget.disabled = true

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: data,
        headers: { "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content }
      })

      const json = await response.json()

      if (response.ok) {
        form.reset()
        this.updateCharCount()
        this.showSuccess(json.success)
      } else {
        this.showError(json.error || this.element.dataset.errorRequired)
        this.submitBtnTarget.disabled = false
      }
    } catch {
      this.showError(this.element.dataset.errorRequired)
      this.submitBtnTarget.disabled = false
    }
  }

  showSuccess(msg) {
    if (this.hasSuccessMsgTarget) {
      this.successMsgTarget.textContent = msg
      this.successMsgTarget.style.display = "block"
    }
  }

  showError(msg) {
    if (this.hasErrorMsgTarget) {
      this.errorMsgTarget.textContent = msg
      this.errorMsgTarget.style.display = "block"
    }
  }

  hideMessages() {
    if (this.hasSuccessMsgTarget) this.successMsgTarget.style.display = "none"
    if (this.hasErrorMsgTarget)   this.errorMsgTarget.style.display = "none"
  }
}
